/*eslint no-unused-vars: "error"*/

import './module/_multi_Korrektur.js';
import './module/pdfjs_redactor.js';

// import './module/modul_form.js';
import 'cookieconsent';
window.cookieconsent.initialise({
    "palette": {
        "popup": {
            "background": "#529735"
        },
        "button": {
            "background": "#154a93"
        }
    },
    "content": {
        "message": "Diese Website nutzt Cookies, um Ihnen eine bestmögliche Funktionalität bieten zu können. Details finden Sie in der",
        "dismiss": "Verstanden",
        "link": "Datenschutzerklärung",
        "href": "https://eco-congress.com/de/datenschutzerklaerung.html"
    }
});

import 'magnific-popup';
// import './module/congress_magnificPopup.js';
import './module/magnificPopup_universal.js';

import './module/modul_form.js';
import './module/modul_accordion2.js';
import './module/modul_tab.js';
import './module/subnav2.js';

// import 'pdfjs-dist'
// import './module/pdf_viewer2.js';

import './module/event_kosten';


  $('.nav_meta_link').magnificPopup({
    type: 'inline',
    closeOnContentClick: false,
    closeOnBgClick: false,
    closeBtnInside: true,
    showCloseBtn: true,
    autoFocusLast: false
  });
  $('.footer_contact_link').magnificPopup({
    type: 'inline',
    closeOnContentClick: false,
    closeOnBgClick: false,
    closeBtnInside: true,
    showCloseBtn: true,
    autoFocusLast: false
  });

  $('.webex_help').magnificPopup({
    type: 'inline',
    closeOnContentClick: false,
    closeOnBgClick: false,
    closeBtnInside: true,
    showCloseBtn: true,
    autoFocusLast: false
  });


  

// $(function() {
//     $('a.collection_comments_link:contains("No Comments")').css('display', 'none');
// });


// temp image for update ProfilePhoto
var docphotoid = document.getElementById("photo");
if (docphotoid) {
    document.getElementById("photo").onchange = function() {
        updateProfilePhoto()
    };
}

function updateProfilePhoto() {
    if (document.getElementById("photo").value != '') {
        document.getElementById("update-profile_photo").src = "../assets/congress_media/avatar/avatar_update.png"
    }
}


// MatchHeight mit MediaQuery

import {
    MatchHeight
} from 'js-match-height';

function myFunction(x) {
    if (x.matches) { // If media query matches
    } else {
        /* eslint-disable no-unused-vars */
        const matchHeight = new MatchHeight('.cc_navGrid2 section');
        /* eslint-enable no-unused-vars */
    }
}

var x = window.matchMedia("(max-width: 1080px)")
myFunction(x) // Call listener function at run time


// Reload Comments
var docpvanillaComments_reloadhotoid = document.getElementById("vanillaComments_reload");
if (docpvanillaComments_reloadhotoid) {
    document.getElementById("vanillaComments_reload").onclick = function() {
        document.getElementById("vanilla-comments").children[0].contentWindow.location.reload(true)
    };
}
var docpvanillaComments_reloadhotoid2 = document.getElementById("vanillaComments_reload2");
if (docpvanillaComments_reloadhotoid2) {
    document.getElementById("vanillaComments_reload2").onclick = function() {
        document.getElementById("vanilla-comments").children[0].contentWindow.location.reload(true)
    };
}



// import FlexMasonry from '../../node_modules/flexmasonry/src/flexmasonry.js';
// FlexMasonry.init('.cc_grid', {
//     responsive: false,
//     numCols: 2
// });

// FIX the flicker beim Laden
// document.addEventListener('DOMContentLoaded', function() {
//     setTimeout(flexmasonry_visible, 450);
// });

// function flexmasonry_visible() {
//     const flexmasonry_wrappers = document.querySelectorAll(".flexmasonry2");
//     for (var a = 0; a < flexmasonry_wrappers.length; a++) {
//         flexmasonry_wrappers[a].classList.remove('is-invisible');
//     }
// }





import $ from 'jquery';
import Masonry from 'masonry-layout';
import jQueryBridget from 'jquery-bridget';
import imagesLoaded from 'imagesloaded';

jQueryBridget('masonry', Masonry, $);
jQueryBridget('imagesLoaded', imagesLoaded, $);

const $container = $('#poster_wrapper');

$container.imagesLoaded(() => {
    $container.masonry({
        // columnWidth: 200,
        itemSelector: '.flexmasonry_item_wrapper'
    });
});

function masonryGrid() {
    var $container = $('#poster_wrapper');
    // initialize
    $container.masonry({
        itemSelector: '.flexmasonry_item_wrapper',
        // columnWidth: '.flexmasonry_item_wrapper', //as you wish , you can use numeric 
        isAnimated: true
    });
    $container.masonry('reloadItems');
    $container.masonry('layout');
}




import mixitup from 'mixitup';

// var mixer = mixitup('.poster_wrapper');

var poster_wrapper = document.getElementById("poster_wrapper");
if (poster_wrapper) {
    /* eslint-disable no-unused-vars */
    var mixer = mixitup(document.getElementById("poster_wrapper"), {
        classNames: {
            block: '',
            elementFilter: ''
        },
        debug: {
            enable: true
        }
    });
    /* eslint-enable no-unused-vars */
}





// console.log(mixer);





$(function() {
    $('.poster_wrapper').on('mixLoad', function() {
        // console.log('[event-handler] MixItUp Loaded');
    });

    $('.poster_wrapper').on('mixStart', function() {
        // console.log('[event-handler] Animation Started');



    });

    $('.poster_wrapper').on('mixEnd', function() {
        // console.log('[event-handler] Animation Ended');
        masonryGrid();


        // FlexMasonry.refresh(document.getElementById("poster_wrapper"), {
        //     responsive: false,
        //     numCols: 2
        // });

        // FlexMasonry.refreshAll({
        //     responsive: true,
        //     breakpointCols: {
        //         'min-width: 1400px': 2,
        //         'min-width: 700px': 2
        //     },
        //     numCols: 2
        // });

    });
});



// import {atcb_init} from 'add-to-calendar-button';
// document.addEventListener('DOMContentLoaded', atcb_init, false);

// frame.addEventListener("load", ev => {
//     const new_style_element = document.createElement("style");
//     new_style_element.textContent = "#Content h2 { display: none; }"
//     ev.target.contentDocument.head.appendChild(new_style_element);
// });